import React, { useContext } from "react";

import { EventContext } from "@gp/components";
import { EventOffer } from "@gp/offer";
import { getOfferHistoryScore } from "@utils/offer/offerHistoryScore";
import { observer } from "mobx-react";

export const OfferHistoryResult = observer(function OfferHistoryResult() {
	// @ts-expect-error
	const event: EventOffer = useContext(EventContext);

	const score = getOfferHistoryScore(event?.result);

	return (
		<div className="match__score">
			<div className="match__score__wrapper">
				<div className="match__score__ft">
					<div>{score.fullTime?.home}</div>
					<div>{score.fullTime?.away}</div>
				</div>
			</div>
		</div>
	);
});
